import _ from 'lodash';
import moment from 'moment';
import TableView from '@/components/dashboard/Accounting/AccountingStatement/TableView.vue';
import { fetchNormalRowDatas, updateTableData } from './utils';

export default {
    components: {
        TableView,
        DetailDialog: () => import('@/components/ui/ahAccountingGeneralLedgerDialog.vue'),
    },
    computed: {
        todayDateTxt() {
            return moment().format('YYYY年MM月DD日');
        },
        settlementDateTxt() {
            return this.settlementDate ? moment(this.settlementDate).format('YYYY年MM月DD日') : null;
        },
        closedDateTxt() {
            return this.annualAccountingTaskStatus === 2 && this.closedDate ? moment(this.closedDate).format('YYYY年MM月DD日') : null;
        },
        startDateTxt() {
            const DATE = moment(+this.queryParams.StartDate);
            return `${DATE.year() - 1911}年${DATE.format('MM月DD日')}`;
        },
        endDateTxt() {
            const DATE = moment(+this.queryParams.EndDate);
            return `${DATE.year() - 1911}年${DATE.format('MM月DD日')}`;
        },
        isStartEndDateSameYear() {
            return moment(Number(this.dateRange[0])).year() === moment(Number(this.dateRange[1])).year();
        },
    },
    data() {
        return {
            isLoading: false,
            displayMode: 1,
            queryParams: {
                StartDate: null,
                EndDate: null,
            },
            annualAccountingTaskStatus: null,
            settlementDate: null,
            closedDate: null,
            openDate: null,
            isShowZeroItems: true,
            dateRange: [null, null],
            tableData: [],
            monthlyTableData: [],
            detailDialog: {
                accno: null,
                accnam: null,
                visible: false,
            },
        };
    },
    methods: {
        async updateData() {
            if (!this.isStartEndDateSameYear) {
                this.$message({
                    showClose: true,
                    message: '不可跨年度查詢，請重新選擇日期範圍。',
                    type: 'error',
                });
                return;
            }
            this.updateQuery();
            this.isLoading = true;
            await this.getYearlyOpenVoucher();
            if (!this.checkQueryValidate()) return;

            try {
                const rawData = await fetchNormalRowDatas(this.queryParams.StartDate, this.queryParams.EndDate);
                this.tableData = updateTableData(rawData, this.isShowZeroItems);
                this.annualAccountingTaskStatus = rawData.annualAccountingTaskStatus;
                this.settlementDate = rawData.lastSettlementBelongDate;
                this.closedDate = rawData.lastClosedOperationTime;
            } finally {
                this.isLoading = false;
            }
        },
        updateQuery() {
            this.queryParams.StartDate = _.head(this.dateRange);
            this.queryParams.EndDate = _.last(this.dateRange);
        },
        async getYearlyOpenVoucher() {
            const OPEN_DATE = moment(+this.openDate);
            const SELECTED_END_DATE = moment(+this.queryParams.EndDate);
            const SELECTED_START_DATE = moment(+this.queryParams.StartDate);

            if (this.openDate && OPEN_DATE.year() === SELECTED_END_DATE.year() && SELECTED_START_DATE.isAfter(OPEN_DATE)) return;
            if (OPEN_DATE.year() === SELECTED_END_DATE.year() && SELECTED_START_DATE.isBefore(OPEN_DATE)) {
                this.$message({
                    showClose: true,
                    message: `${SELECTED_START_DATE.year()}年開帳日期為 ${OPEN_DATE.format('YYYY-MM-DD')}，已自動將查詢起日設為開帳日期。`,
                    type: 'warning',
                });
            }

            const resp = await this.$api({
                url: 'AccountingSummaryPage/QueryVouchers',
                method: 'GET',
                params: {
                    StartDateStart: moment(+this.queryParams.StartDate)
                        .startOf('year')
                        .format('x'),
                    StartDateEnd: moment(+this.queryParams.StartDate)
                        .endOf('year')
                        .format('x'),
                    TransactionType: 12,
                },
            });

            if (resp.data.totalNum) {
                this.openDate = _.head(resp.data.items)?.dat;
                this.dateRange = [this.openDate, this.dateRange[1]];
            } else this.openDate = null;

            this.updateQuery();
        },
        checkQueryValidate() {
            const OPEN_DATE = moment(+this.openDate);
            const SELECTED_DATE = moment(+this.queryParams.EndDate);
            if (this.openDate && SELECTED_DATE.isBefore(OPEN_DATE)) {
                this.$message({
                    showClose: true,
                    message: `${SELECTED_DATE.year()}年開帳日期為 ${OPEN_DATE.format('YYYY-MM-DD')}，請重新選擇日期範圍。`,
                    type: 'error',
                });
                return false;
            }
            return true;
        },
        normalizeNumber(num) {
            return parseFloat(Math.round(num * 10000) / 100).toFixed(2);
        },
        onClickItem(item) {
            if (!item.level) return;

            this.detailDialog.accno = item.id;
            this.detailDialog.accnam = item.name;
            this.detailDialog.visible = true;
        },
    },
};
